<template>
  <div>
    <v-app-bar class="py-2 pr-1" min-height="70" app color="#ffffff">
      <v-row class="pb-2 text-center" justify="space-between" align="center">
        <v-col cols="2">
          <router-link to="/">
            <v-img
              class="py-2"
              contain
              max-height="45"
              min-width="90"
              :src="require('@/assets/logo.png')"
            />
          </router-link>
        </v-col>
        <!-- PlatJaMの使い方表示 -->
        <!-- 画面サイズxsの場合表示なし（ハンバーガーメニューに移動予定） -->
        <v-col v-if="!$vuetify.breakpoint.name.match(/^(xs)$/)" cols="3" style="font-size: small; white-space: nowrap">
          <router-link to="/howtouse" class="router-link">
            <v-avatar>
              <v-icon>mdi-fountain-pen-tip</v-icon>
            </v-avatar>
            <span>
              ご利用方法
            </span>
          </router-link>
        </v-col>
        <!-- ユーザーIDの表示 -->
        <!-- 画面サイズxsの場合文字の大きさをcaptionに変更、パティングをpx-0を設定 -->
        <v-col v-if="!$vuetify.breakpoint.name.match(/^(xs)$/)" cols="3" style="font-size: small">
          <div v-if="isSignedIn && $store.state.username !== ''" style="white-space: nowrap">
            <v-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            <span>
              {{ formattedUserName }}
            </span>
          </div>
        </v-col>
        <v-col v-else cols="6" class="caption px-0">
          <div v-if="isSignedIn && $store.state.username !== ''">
            <v-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            <span>
              {{ formattedUserName }}
            </span>
          </div>
        </v-col>
        <!-- サインイン表示（条件分岐） -->
        <!-- 画面サイズxsの場合ボタンの大きさをx-smallに変更 -->
        <div v-if="$vuetify.breakpoint.name!=='xs'">
          <v-col v-if="!isSignedIn" cols="3">
            <router-link to="/sign-in">
              <v-btn
                v-if="$vuetify.breakpoint.name.match(/^(xs)|(sm)$/)"
                small
                color="red"
                rounded
                dark
              >
                サインイン
              </v-btn>
              <v-btn
                v-else
                color="red"
                rounded
                dark
              >
                サインイン
              </v-btn>
            </router-link>
          </v-col>
          <v-col v-else cols="3">
            <router-link to="/sign-out">
              <v-btn
                v-if="$vuetify.breakpoint.name.match(/^(xs)|(sm)$/)"
                small
                color="blue"
                rounded
                dark
              >
                サインアウト
              </v-btn>
              <v-btn
                v-else
                color="blue"
                rounded
                dark
              >
                サインアウト
              </v-btn>
            </router-link>
          </v-col>
        </div>
        <div v-else>
          <v-col cols="3">
            <v-app-bar-nav-icon v-if="$vuetify.breakpoint.name=='xs'" @click="drawer = true">
              <v-icon large>
                mdi-menu
              </v-icon>
            </v-app-bar-nav-icon>
          </v-col>
        </div>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
    >
      <v-list
        nav
        dense
      >
        <!-- ハンバーガーメニュー -->
        <v-list-item-group>
          <!-- クローズボタン -->
          <!-- マテリアルデザインから×を選べる -->
          <v-list-item-title class="py-5" @click="drawer = false">
            <div class="my-4">
              <v-row justify="center">
                <v-icon
                  color="green darken-2"
                >
                  mdi-close
                </v-icon>
                閉じる
              </v-row>
            </div>
          </v-list-item-title>
          <v-divider />
          <!-- サインイン表示（条件分岐） -->
          <!-- 画面サイズによるボタンの大きさの変更をする処理を削除 -->
          <v-list-item-title class="py-5">
            <v-row class="text-center">
              <v-col v-if="$store.state.user==null">
                <router-link to="/sign-in">
                  <v-btn
                    color="red"
                    class="no-decoration white--text text-caption"
                    rounded
                    dark
                  >
                    サインイン
                  </v-btn>
                </router-link>
              </v-col>
              <!-- サインアウト（条件分岐） -->
              <!-- 画面サイズによるボタンの大きさの変更をする処理を削除 -->
              <v-col v-else>
                <router-link to="/sign-out">
                  <v-btn
                    color="blue"
                    rounded
                    dark
                  >
                    サインアウト
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-list-item-title>
          <v-divider />
          <v-list-item-title class="py-5" align="center">
            <router-link to="/howtouse" class="router-link">
              <span>
                ご利用方法
              </span>
            </router-link>
          </v-list-item-title>
          <v-divider />
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import store from '@/store/store'
import repository from '@/store/repository'

export default {
  name: 'AppBar',
  data () {
    return {
      displayUsername: store.state.username,
      drawer: false,
      x: 221034234,
      y: 112342509,
      z: 987245243,
      t: null
    }
  },
  computed: {
    isSignedIn: function () {
      return repository.isSignedIn()
    },

    formattedUserName: function () {
      const name = store.state.username
      if (!name) return ''

      if (name.includes('google')) {
        let seed = Number(name.slice(-9))
        for (let i = 0; i < 5; i++) {
          seed = this.xorShift(seed)
        }
        return `googleuser${String(seed).slice(-6)}`
      } else {
        return name.toUpperCase()
      }
    }
  },
  methods: {
    xorShift: function (seed) {
      this.t = this.x ^ (this.x << 11)
      this.x = this.y
      this.y = this.z
      this.z = seed
      seed = (seed ^ (seed >>> 19)) ^ (this.t ^ (this.t >>> 8))
      return seed
    }

  }
}
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}

.router-link {
  color: black;
  text-decoration:none;
}

.v-toolbar__title {
  color: white;
  text-decoration: none;
}
</style>
